import "./Treatments.module.css";
import UstMenu from "@/reusable_sections/Header";
import AboutSelcukluCafe from "./sections/AboutSelcukluCafe";
import PromoCards from "./sections/PromoCards";
import StartChangeToday from "./sections/StartChangeToday";
import CorporateFooter from "@/reusable_sections/Footer";
export default function TreatmentsPage() {
  return <div>
      <UstMenu />
      <AboutSelcukluCafe />
      <PromoCards />
      <StartChangeToday />
      <CorporateFooter />
    </div>;
}